import { CONST_DEL_GENRE_FILTER } from 'features/Genre/constans';
import { Genre } from 'features/Genre/models/Genre';
import serviceDetail from 'features/Genre/pages/detail/services';
import service from 'features/Genre/pages/list/services';
import { useEffect, useRef, useState } from 'react';
import { Col, Form, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { TfiReload } from 'react-icons/tfi';
import DetailModal from './Detail';
// define props
interface DataTableProps {
  dataTable: Genre[];
  setDataTable: (dataTable: Genre[] | []) => void;
  handleBtnOnReflect: (selectedGenres: Array<{ id: number; name: string }>) => void;
  exceptGenreIds?: number[];
}

function TableList({ dataTable, setDataTable, handleBtnOnReflect, exceptGenreIds }: DataTableProps) {
  const { t } = useTranslation();
  const initialState = dataTable.reduce((o, key) => ({ ...o, [key.id]: false }), {});
  const [checked, setChecked] = useState<any>(initialState);
  const refBtnOnReflect = useRef<HTMLButtonElement>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [genre, setGenre] = useState<Genre>();

  // handle checked all
  function handleCheckedAll() {
    const newState = dataTable.reduce((o, key) => ({ ...o, [key.id]: true }), {});
    setChecked(newState);
  }

  // handle unchecked all state changes
  function handleUncheckedAll() {
    const newState = dataTable.reduce((o, key) => ({ ...o, [key.id]: false }), {});
    setChecked(newState);
  }

  // toggle checkbox
  function toggleCheck(value: number) {
    let newState = { ...checked };
    newState[value] = !newState[value];
    setChecked(newState);
  }

  // handle reload
  async function handleReload() {
    await service.getGenres('', CONST_DEL_GENRE_FILTER.ALL).then((result) => {
      setDataTable(result.data);
    });
    handleUncheckedAll();
  }

  // useEffects check change checked
  useEffect(() => {
    // handle disabled btn view detail
    function handleDisableBtnViewDetail() {
      let count = Object.keys(checked).filter((key) => checked[key] === true).length;
      if (count > 0) {
        return false;
      }
      return true;
    }

    if (handleDisableBtnViewDetail()) {
      if (refBtnOnReflect.current) refBtnOnReflect.current.disabled = true;
    } else {
      if (refBtnOnReflect.current) refBtnOnReflect.current.disabled = false;
    }
  }, [checked]);

  // close modal edit
  function handleCloseModalEdit(status: boolean) {
    setShowEditModal(false);
    if (status) handleReload();
  }

  function handlOnReflect() {
    let ids = Object.keys(checked)
      .filter((key) => checked[key] === true)
      .map((value) => parseInt(value));

    const selectedGenres: Array<{ id: number; name: string }> = dataTable
      .filter((item) => ids.includes(item.id))
      .map((dataItem) => {
        return { id: dataItem.id, name: dataItem.name };
      });
    handleBtnOnReflect(selectedGenres);
  }

  async function handleDefaultGenre(event: any) {
    const id = event.currentTarget.getAttribute('data-id');
    if (id) {
      await serviceDetail
        .getGenre(id)
        .then((data) => {
          return data.data;
        })
        .then((data) => {
          setGenre(data);
          setShowEditModal(true);
        });
    }
  }

  return (
    <>
      {genre && <DetailModal genre={genre} show={showEditModal} handleCloseModalEdit={handleCloseModalEdit} />}
      <Row className="mb-2">
        <Col sm={6} lg={6}>
          <button className="link" onClick={handleCheckedAll}>
            {t('Genre.Button.select_all')}
          </button>{' '}
          /{' '}
          <button className="link" onClick={handleUncheckedAll}>
            {t('Genre.Button.cancel_all')}
          </button>
          <span className="ps-2 pe-2"></span>
          <button type="button" onClick={handleReload} className="btn-primary btn-circle">
            <TfiReload />
          </button>
          {t('Genre.Button.reload')}
        </Col>
        <Col sm={6} lg={6} className="d-flex justify-content-end">
          <span className="ps-2 pe-2"></span>
          <button type="button" className="btn btn--dark-green" ref={refBtnOnReflect} onClick={handlOnReflect}>
            {t('Genre.Button.add_new')}
          </button>
        </Col>
      </Row>
      <div className="sticky-table" style={{ maxHeight: '500px' }}>
        <Table bordered>
          <thead className="text-center" style={{ backgroundColor: '#36489a', color: '#fff' }}>
            <tr>
              <th rowSpan={2} className="align-top" style={{ width: '5%' }}>
                {t('Genre.Table.selection')}
              </th>
              <th rowSpan={1} className="align-top" style={{ width: '20%' }}>
                {t('Genre.Table.genre_name')}
              </th>
            </tr>
          </thead>
          <tbody>
            {dataTable &&
              dataTable.map((value: Genre) => (
                <tr key={value.id}>
                  {exceptGenreIds?.includes(value.id) === false && !value.delete_flg && (
                    <>
                      <td className="text-center">
                        <Form.Check
                          type="checkbox"
                          className="custom-checkbox"
                          value={value.id}
                          checked={checked[value.id]}
                          onChange={() => toggleCheck(value.id)}
                          disabled={exceptGenreIds?.includes(value.id)}
                        />
                      </td>
                      <td className="text-center">
                        <button
                          className="pull-right html-link"
                          onClick={handleDefaultGenre}
                          data-id={value.id}
                          style={{ cursor: 'pointer' }}
                        >
                          {value.name}
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    </>
  );
}

export default TableList;
